import CInputElement from '@components/form/Element';

export default {
    components: { CInputElement },
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            required: false
        },
        label: String,
        sublabel: String,
        helptext: String,
        horizontal: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        value: {
            get() {
                return this.modelValue;
            },
            set( value ) { 
                this.$emit('update:modelValue', value);
            }
        },
    },
}